import React, { ReactElement } from 'react';
import PngTemplateArt from './PngTemplateArt';
import pencilSketchImage from '../assets/pencil-sketch.png';

interface WentWellArtProps {
  isDarkMode: boolean;
}

export default function WentWellArt({ isDarkMode }: WentWellArtProps): ReactElement {
  return <PngTemplateArt src={pencilSketchImage} isDarkMode={isDarkMode} />;
}
